import React, { useState } from "react";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import { toast } from "react-toastify";
import axios from "axios"; // Import axios for making HTTP requests
import { useSelector } from "react-redux";
import userApis from "apis/users";

const info = [
  {
    title: "🗺 SITE ADDRESS",
    desc: "Hebsur",
  },
  {
    title: "💌 EMAIL",
    desc: "admin@sriestate.com",
  },
  {
    title: "☎ PHONE",
    desc: "9242357004, 9901606012",
  },
  {
    title: "🗺 OFFICE ADDRESS",
    desc: "Sri Estate Developer,\nC/o Manomay Associates,\n92, 3rd Floor, Satellite Complex\n Koppikar Road, HUBLI",
  },
];

const PageContact = ({ className = "" }) => {
  // State for each input field
  const [name, setFullName] = useState("");
  const [phoneNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const jwt = useSelector((state) => state?.auth?.jwt);

  const api = new userApis(jwt);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    // Create the data object to send to the API
    const contactData = {
      name,
      phoneNumber,
      email,
      message,
    };

    try {
      // Send POST request to the API
      await api.contactUs(contactData);

      toast.success("We will contact you soon");
      // Reset the form state
      setFullName("");
      setMobileNumber("");
      setEmail("");
      setMessage("");
    } catch (error) {
      toast.error("There was an issue submitting the form. Please try again.");
    }
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <Helmet>
        <title>Contact || Booking React Template</title>
      </Helmet>
      <div className="mb-24 lg:mb-32">
        <h2 className="my-16 sm:my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Contact
        </h2>
        <div className="container max-w-7xl mx-auto">
          <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-12 ">
            <div className="max-w-sm space-y-8">
              {info.map((item, index) => (
                <div key={index}>
                  <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                    {item.title}
                  </h3>
                  <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                    {item.desc}
                  </span>
                </div>
              ))}
              <div>
                <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                  🌏 SOCIALS
                </h3>
                <SocialsList className="mt-2" />
              </div>
            </div>
            <div>
              <div className="grid grid-cols-1 gap-6">
                <form onSubmit={handleSubmit}>
                  <label className="block">
                    <Label>Full name</Label>
                    <Input
                      // placeholder="Example Doe"
                      type="text"
                      className="mt-1"
                      value={name}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </label>
                  <label className="block">
                    <Label>Mobile Number</Label>
                    <Input
                      // placeholder="7829392829"
                      type="text"
                      className="mt-1"
                      value={phoneNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                    />
                  </label>
                  <label className="block">
                    <Label>Email address</Label>
                    <Input
                      type="email"
                      // placeholder="example@example.com"
                      className="mt-1"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </label>
                  <label className="block">
                    <Label>Message</Label>
                    <Textarea
                      className="mt-1"
                      rows={6}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </label>
                  <div>
                    <ButtonPrimary type="submit">Send Message</ButtonPrimary>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* OTHER SECTIONS */}
      <div className="container">
        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay uniqueClassName="Pagecontact_" />
        </div>
        {/* <SectionSubscribe2 className="py-24 lg:py-32" /> */}
      </div>
    </div>
  );
};

export default PageContact;
